<template>
  <v-dialog
    :value="shown"
    persistent
    max-width="450"
    @click:outside="hideModal"
    @keydown.esc="hideModal"
  >
    <div class="modal-body">
      <div class="card-head">
        <v-btn
          icon
          dark
          @click="hideModal"
          class="hide-button"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h2>{{ title }}</h2>
      </div>
      <div class="card-body">
        <p>{{ message }} to your <router-link to="/my-deals">selected deals</router-link> list.</p>
        <p>We will follow up shortly.</p>
      </div>
      <div class="controls">
        <v-btn color="#f0b323" @click="hideModal">OK</v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'selected-modal',
  props: {
    shown: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 1
    }
  },
  computed: {
    title () {
      return this.count > 1 ? 'Deals have been added' : 'Deal has been added'
    },
    message () {
      return this.count > 1 ? `${this.count} Deals have been added` : '1 Deal has been added'
    }
  },
  methods: {
    hideModal () {
      this.$emit('hide')
    }
  }
}
</script>

<style scoped lang="scss">
.hide-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
.modal-body {
  background: #FFFFFF;
  box-shadow: 0px 23px 28px rgba(0, 0, 0, 0.213768);
  border-radius: 7px;
}
.card-head {
  position: relative;
  background: #18305A;
  height: 60px;
  display: flex;
  align-items: flex-end;
  padding-left: 25px;
  h2 {
    color: #fff;
    padding-bottom: 10px;
  }
}
.card-body {
  padding: 30px 25px 40px;
}
.controls {
  text-align: center;
  padding-bottom: 30px;
}
</style>
